'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _modal = require('redux/actions/modal');

var _auth = require('redux/actions/auth');

var _modal_type = require('redux/actions/modal_type');

var _pass_recovery = require('redux/actions/pass_recovery');

var _constants = require('redux/constants');

var _PassRecovery = require('components/PassRecovery');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PassRecovery: {
        displayName: 'PassRecovery'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/PassRecovery/PassRecovery.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PassRecovery = _wrapComponent('PassRecovery')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        user: state.auth.user,
        step: state.passRecovery.step,
        preload: state.auth.preload,
        login: state.passRecovery.phone,
        lang: state.lang
    };
}, {
    hide: _modal.hide,
    load: _auth.load,
    resetStep: _pass_recovery.resetStep,
    sendCode: _pass_recovery.sendCode,
    showModalRegistration: _modal_type.showModalRegistration
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(PassRecovery, _Component);

    function PassRecovery(props) {
        (0, _classCallCheck3.default)(this, PassRecovery);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecovery.__proto__ || (0, _getPrototypeOf2.default)(PassRecovery)).call(this, props));

        _this.changeFieldLogin = function (login) {
            _this.setState({ 'login': login });
        };

        _this.changeFieldPassword = function (password) {
            _this.setState({ 'password': password });
        };

        _this.changeFieldCode = function (code) {
            _this.setState({ 'code': code });
        };

        _this.renderComponent = function () {
            switch (_this.props.step) {
                case _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_2:
                    return _react3.default.createElement(_PassRecovery.PassRecoveryStepTwo, {
                        login: _this.state.login,
                        password: _this.state.password,
                        code: _this.state.code,
                        changeFieldCode: _this.changeFieldCode,
                        changeFieldPassword: _this.changeFieldPassword
                    });

                case _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_3:
                    return _react3.default.createElement(_components2.Preloader, { preload: true });

                case _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_1:
                default:
                    return _react3.default.createElement(_PassRecovery.PassRecoveryStepOne, {
                        login: _this.state.login,
                        changeFieldLogin: _this.changeFieldLogin
                    });
            }
        };

        _this.state = {
            login: props.login,
            password: '',
            code: ''
        };
        return _this;
    }

    (0, _createClass3.default)(PassRecovery, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.step === _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_3) {
                this.setState({
                    password: '',
                    login: '',
                    code: ''
                });

                this.props.load();
                if (!!nextProps.user) {
                    this.props.hide();
                    setTimeout(function () {
                        _reactSAlert2.default.success(_this2.props.lang['store.password_recovery.success'], { position: 'top-right', effect: 'slide', timeout: 5000 });
                    }, 1000);
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetStep();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react3.default.createElement(
                'div',
                null,
                this.renderComponent()
            );
        }
    }]);
    return PassRecovery;
}(_react2.Component), _class2.propTypes = {
    hide: _react2.PropTypes.func.isRequired,
    load: _react2.PropTypes.func.isRequired,
    resetStep: _react2.PropTypes.func.isRequired,
    sendCode: _react2.PropTypes.func.isRequired,
    showModalRegistration: _react2.PropTypes.func.isRequired,
    lang: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = PassRecovery;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecovery.jsx
// module id = 1719
// module chunks = 0